<template>
    <div id="news-language-selection-portal" class="nav-header__right news_header-right" v-if="['news','competitionNews','latestNews'].includes($route.name)"></div>
    <!-- 123 -->
</template>

<style scoped>

#news-language-selection-portal {
}

@media(max-width: 768px) { /* for test */
  .news-language__selection-wrapper {
  }
  #news-language-selection-portal {
    /* padding-right: 1rem; */
    background-color: var(--white-1000);
    width: 100%;
  }
}
</style>